import { render, staticRenderFns } from "./ParagraphTitle.vue?vue&type=template&id=981c60ce&scoped=true"
var script = {}
import style0 from "./ParagraphTitle.vue?vue&type=style&index=0&id=981c60ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981c60ce",
  null
  
)

export default component.exports